// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yrlt","list":"styles_list__3I-q0","listItem":"styles_listItem__1gwLr","link":"styles_link__2wKUa","active":"styles_active__3YV-O"};